import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillingProcess } from '../../../models/billingProcess.interface';
import { ActivityLogResponse, ActivityParams } from 'src/models/activity.interface';
import { BillingService } from '../services/billing.service';

@Component({
  selector: 'app-billing-process-details-dialog',
  templateUrl: './billing-process-details-dialog.component.html',
  styleUrls: ['./billing-process-details-dialog.component.css'],
})
export class BillingProcessDetailsDialogComponent implements OnInit {

  billingProcess: BillingProcess = {
    OrderId: 0,
    id: '',
    status: '',
    totalProviders: 0,
    failedProvidersAmount: 0,
    sentProvidersAmount: 0,
    date: '',
    billingStartDate: '',
    billingEndDate: '',
    providers: [],
    filters: [],
  };

  activityLog: ActivityParams[] = [];
  currentPage: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string, pageIndex: number },
    private billingService: BillingService
  ) {
    this.currentPage = data.pageIndex || 1;
  }

  ngOnInit() {
    this.loadBillingProcessDetails();
    this.loadActivityLog(this.currentPage);
  }

  loadBillingProcessDetails() {
    this.billingService.getBillingProcessDetails(this.data.id).subscribe(
      (process: BillingProcess) => {
        this.billingProcess = process;
      },
      (error) => {
        console.error('Error loading billing process details', error);
      }
    );
  }

  loadActivityLog(page: number = 1) {
    const processId = this.data.id;
    const params: ActivityParams = { provider_id: parseInt(processId, 10) };

    this.billingService.getListActivity(params, page).subscribe(
      (log: ActivityLogResponse) => {
        const filteredResults = log.results.filter(event => {
          return event.descriptionAsArray && event.descriptionAsArray.some(desc => desc.includes(processId));
        });

        // Verificamos duplicados usando un Set para el campo `id`
        const uniqueResults = this.removeDuplicates(filteredResults);

        this.activityLog = uniqueResults;

      },
      (error) => {
        console.error('Error loading activity log', error);
      }
    );
  }

  removeDuplicates(events: ActivityParams[]): ActivityParams[] {
    const seenIds = new Set();
    return events.filter(event => {
      if (seenIds.has(event.id)) {
        return false;
      } else {
        seenIds.add(event.id);
        return true;
      }
    });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadActivityLog(page);
  }
}
